import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import * as FileSaver from "file-saver";

import {
  RouterLinkRenderer,
  DatepickerEditor,
  Container,
  Generator,
  ViewService,
  ContainerService,
  SearchParams,
  GeneratorService,
} from "../../common";
import { DatePipe } from "@angular/common";

@Component({
  selector: "container-list-view",
  templateUrl: "./container-list-view.component.html",
  styleUrls: ["./container-list-view.component.css"],
  standalone: false,
})
export class ContainerListView implements OnInit {
  searchCriteria: string;
  actions: any[];

  private gridApi;
  public columnDefs;
  public defaultColDef;
  public components;
  public frameworkComponents;
  public editType;
  container: Container;
  approvalCanceled: boolean = false;
  selectedCount: number;
  canPrintContainer: (rowNode: any) => any;

  constructor(
    public viewService: ViewService,
    public containerService: ContainerService,
    public generatorService: GeneratorService
  ) {
    viewService.setViewData({
      pageTitle: "Containers",
      link: { text: "» New", routeData: ["/containers/new"] },
      breadcrumbs: false,
    });

    this.initManifestGrid();
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  navigate(params: any): void {
    this.viewService.router.navigate(["/containers", params]);
  }

  onCellValueChanged(event) {
    if (event.newValue !== event.oldValue) {
      if (!event.node.changedValues) event.node.changedValues = [];

      event.node.changedValues.push(event.colDef.field);
    }
  }
  onSelectionChanged(event) {
    this.selectedCount = event.api.getSelectedNodes().length;
  }

  checkBoxPrint(state: boolean) {
    return state
      ? `<label class="custom-checkbox"><input type="checkbox" checked /><span class="checkmark"></span></label>`
      : `<input type="checkbox" />`;
  }
  printSelectedContainer() {
    this.generatorService.getActive().subscribe((generators) => {
      this.containerService.printLayout().subscribe((printLayout) => {
        console.log(printLayout);
        const generator: Generator = generators.data[0];
        let selectedNodes = this.gridApi.getSelectedNodes();

        let selectedData = selectedNodes.map((node) => node.data);
        let html = ``;
        selectedData.forEach((ctn: Container) => {
          html = `${html}
                  <div id="page1" class="label-style" style="page-break-before: always;">
                      <div style="text-align:center; color:red;  font-size:50px;">HAZARDOUS WASTE </div>
                      <div style=" text-align:center;">STATE AND FEDERAL LAW PROHIBIT IMPROPER DISPOSAL </div>
                      <div style=" text-align:center;" class="font_small">
                      <br />
                      IF FOUND, CONTACT THE NEAREST POLICE OR PUBLIC SAFETY AUTHORITY, OR THE U.S. ENVIRONMENTAL PROTECTION AGENCY, OR THE CALIFORNIA DEPARTMENT OF TOXIC SUBSTANCES CONTROL.
                      </DIV>        
                      <span class="font_small">D.O.T PSN:&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      <span id="DOT_description1" class="font_halfinch">${ctn.dotNumber}</span>
                      <span id="DOT_description2" class="font_medium">${ctn.dotText}</span>
                      <br />
                      <br />
                      <span class="font_small">WASTE CODE(S):&nbsp; &nbsp;&nbsp;</span><span id="wastecodes" class="font_medium">
                      ${ctn.wasteCodesJoin}</span>
                      <br />
                      <br />
                      <table>
                          <tr>
                              <td style="width:200px;">
                                  <span class="font_small">PHYSICAL STATE:</span>
                              </td>
          
                              <td> <span class="font_small">HAZARDOUS PROPERTIES:</span></td>
                          </tr>
                      </table>
                      <table style="width: 100%; height: 49px;">
                          <tr>
                              <td style="position: relative;width: 95px;">
                                  <label class="checkbox-label"></label>
                                  ${this.checkBoxPrint(ctn.isSolid)}
                                  <span class="font_smallbold">&nbsp;SOLID</span> 
                              </td>
                              <td style="position: relative;width: 99px;">
                                  <label class="checkbox-label"></label>
                                  ${this.checkBoxPrint(ctn.isGas)}
                                  <span class="font_smallbold">&nbsp;GAS</span> 
                              </td>
                              <td style="position: relative;width: 125px;">
                                  <label class="checkbox-label"></label>
                                  ${this.checkBoxPrint(ctn.ignitable)}
                                  <span class="font_smallbold">&nbsp;IGNITABLE</span> 
                              </td>
                              <td style="position: relative;">
                                  <label class="checkbox-label"></label>
                                  ${this.checkBoxPrint(ctn.toxic)}
                                  <span class="font_smallbold">&nbsp;TOXIC</span> 
                              </td>
                          </tr>
                          <tr>
                              <td style="position: relative;width: 95px;">
                                  <label class="checkbox-label"></label>
                                  ${this.checkBoxPrint(ctn.isLiquid)}
                                  <span class="font_smallbold">&nbsp;LIQUID</span> 
                              </td>
                              <td style="width: 99px;">&nbsp;</td>
                              <td style="position: relative;width: 125px;">
                                  <label class="checkbox-label"></label>
                                  ${this.checkBoxPrint(ctn.corrosive)}
                                  <span class="font_smallbold">&nbsp;CORROSIVE</span>
                              </td>
                              <td style="position: relative;">
                                  <label class="checkbox-label"></label>
                                  ${this.checkBoxPrint(ctn.reactive)}
                                  <span class="font_smallbold">&nbsp;REACTIVE</span>
                              </td>
                          </tr>
                      </table>
                      <p>          
                          <table style="width: 100%; height: 38px;">
                              <tr style="height: 19px;">
                                  <td><span class="font_small" style="width: 80px;">GENERATOR:</span> </td>
                                  <td class="font_small_medium_bold">${generator.company}</td>
                                  <td>
                                      <span class="font_small">EPA# </span>
                                      <span class="font_small_medium_bold">
                                      ${generator.id}
                                      </span>
                                  </td>
                              </tr>
                              <tr style="height: 19px;">
                                  <td style="width: 80px;"></td>
                                  <td colspan="2" class="font_small_medium_bold">
                                  ${generator.mailingAddress}</td>
                              </tr>                            
                          </table>
                      </p>    
                      <table style="width:100%;">
                          <tr>
                              <td class="font_small" style="width:80px;">START DATE:</td>        
                              <td style="border: 2px solid black; width:100px;">
                                  <span id="start_date" class="font_large">${
                                    ctn.startDateStr
                                  }</span>
                              </td>
                              <td>
                                  <span class="font_small">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MANIFEST#</span>
                                  <span id="shippingpaper_num" class="font_medium">${
                                    ctn.trackingNumber
                                  }</span>
                              </td>
                          </tr>
                      </table>
                      <table style="width:100%;">
                          <tr>
                              <td style="width:44%;">
                                  <span class="font_small">Container ID:&nbsp;</span>
                                  <span id="container_id" class="font_large">${
                                    ctn.containerNumber
                                  }</span>
                              </td>
                              <td style="width:56%;">
                                  <span class="font_small">PROFILE&nbsp;&nbsp;</span>
                                  <span id="TSDF_x0020_Profile_x0020__x0023_" class="font_large">${
                                    ctn.tsdfProfile
                                  }</span>
                              </td>
                              <td></td>
                          </tr>
                      </table>
                  </div>`;
        });

        html = `
        <html lang="en">
          <head>
            <title>Containers Print</title>
            <style>
              ${printLayout}
            </style>
          </head>
          <body>
            ${html}
          </body>
        </html>`;
        setTimeout(() => {
          let printWindwow = window.open("", "_blank", "");
          printWindwow.document.open();
          printWindwow.document.write(html);
          printWindwow.document.close();
          printWindwow.focus();
          setTimeout(() => {
            printWindwow.print();
          }, 250);
        }, 100);
      });
    });
  }

  onRowValueChanged(event) {
    if (event.node.changedValues) {
      console.log(`Changed Values = ${event.node.changedValues.join(",")}`);
      this.save(event.data);
      event.node.changedValues = null;
    }
  }

  performSearch(searchParams: SearchParams): Observable<Container[]> {
    this.searchCriteria = searchParams.search;
    return this.containerService.filterBy(searchParams);
  }
  exportList() {
    const datepipe: DatePipe = new DatePipe("en-US");
    let formattedDate = datepipe.transform(new Date(), "YYYYMMddHHmmss");
    let searchParams = { search: this.searchCriteria } as SearchParams;
    console.log("searchParams: ", searchParams);
    return this.containerService.exportList(searchParams).subscribe(
      (resp) => {
        FileSaver.saveAs(resp, `WIMS-CONTAINERS-${formattedDate}.xlsx`);
      },
      async (error) => {
        const message = JSON.parse(await error.error.text()).message;
        console.log(message);
      }
    );
  }

  save(container: Container) {
    this.containerService.save(container).subscribe(
      (man) => {
        console.log(man);
      },
      (error) => console.log(error)
    );
  }
  ngOnInit(): void {}

  initManifestGrid() {
    this.canPrintContainer = function (rowNode) {
      return rowNode?.data.canPrint;
    };
    this.editType = "fullRow";
    this.frameworkComponents = {
      datePicker: DatepickerEditor,
      btnCellRenderer: RouterLinkRenderer,
    };
    this.columnDefs = [
      {
        headerName: "Edit",
        field: "containerNumber",
        cellRenderer: "btnCellRenderer",
        sortable: false,
        filter: false,
        floatingFilter: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        minWidth: 120,
        maxWidth: 120,
        editable: false,
        pinned: "left",
      },
      {
        headerName: "CTN No",
        field: "containerNumber",
        minWidth: 100,
        maxWidth: 150,
        pinned: "left",
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Start Date",
        field: "startDate",
        minWidth: 120,
        filter: "agDateColumnFilter",
        sortingOrder: ["asc", "desc"],
        cellEditor: "datePicker",
        cellRenderer: (data) => {
          return data.value ? new Date(data.value).toLocaleDateString() : "";
        },
      },
      {
        headerName: "TDSF Profile #",
        field: "tsdfProfile",
        minWidth: 120,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "TDSF Disposal Code",
        field: "tsdfDisposalCode",
        minWidth: 120,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Type",
        field: "wasteType",
        minWidth: 90,
        editable: false,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Stream Name",
        field: "streamName",
        minWidth: 200,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Container Detail",
        field: "containerDetail",
        minWidth: 200,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "DOT Description",
        field: "dotDescription",
        minWidth: 300,
        editable: false,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Volume",
        field: "volumeUn",
        minWidth: 90,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Weight",
        field: "weightUn",
        minWidth: 90,
        editable: false,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "ERG",
        field: "ergNumber",
        minWidth: 50,
        editable: false,
        sortingOrder: ["asc", "desc"],
      },

      {
        headerName: "St. W. Code",
        field: "stateWasteCode",
        minWidth: 50,
        editable: false,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Waste Codes",
        field: "wasteCodesJoin",
        minWidth: 250,
        editable: false,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Tracking No",
        field: "trackingNumber",
        minWidth: 120,
        editable: false,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Shipped",
        field: "shipped",
        minWidth: 90,
        sortingOrder: ["asc", "desc"],
        editable: false,
        refData: boolMapping,
      },
      {
        headerName: "Apvd",
        field: "approved",
        minWidth: 70,
        sortingOrder: ["asc", "desc"],
        cellEditor: "select",
        editable: false,
        cellEditorParams: { values: boolOptions },
        refData: boolMapping,
      },
      {
        headerName: "Open",
        field: "open",
        minWidth: 70,
        sortingOrder: ["asc", "desc"],
        cellEditor: "select",
        editable: false,
        cellEditorParams: { values: boolOptions },
        refData: boolMapping,
      },
    ];
    this.defaultColDef = {
      flex: 1,
      wrapText: true,
      minWidth: 100,
      resizable: true,
      sortable: true,
      floatingFilter: true,
      filter: true,
      autoHeight: true,
      editable: true,
    };
  }
}
let boolMapping = {
  true: "Yes",
  false: "No",
};

let boolOptions = extractValues(boolMapping);

function extractValues(mappings) {
  return Object.keys(mappings);
}
